const SOCIAL_MEDIA_ENTITY_TYPE = 'social_medias';
Object.freeze(SOCIAL_MEDIA_ENTITY_TYPE);

/**
 * newsItem.formData.tt_formats.value,
 * @param {*} newsItem
 * @returns string
 */
export function mapFormats(newsItem) {
	const formats = newsItem?.formData?.tt_formats?.value?.map(f => f.identifier);
	const result = formats?.join(',');

	return result;
}

/**
 * newsItem.formData.tt_language_translated.value.identifier,
 * @param {*} newsItem
 */
export function mapLanguage(newsItem) {
	const langs = newsItem?.formData?.tt_lang_translated?.value?.map(lng => lng.identifier);
	const result = langs?.join(',');
	return result;
}

export function mapMediaId(newsItem) {
	const language = newsItem.locale.language;
	const country = newsItem.locale.country;
	const idPrefix = `${language}_${country}`;
	let _id = undefined;
	if (newsItem.formData.tt_teaser_image.value) {
		_id = `${newsItem.formData.tt_teaser_image.value.identifier}.${idPrefix}`;
	} else if (newsItem.formData.tt_image.value) {
		_id = `${newsItem.formData.tt_image.value.identifier}.${idPrefix}`;
	}

	return _id;
}

export function mapDescription(newsItem) {
	if (newsItem.formData?.tt_teaser_text?.value) {
		return newsItem.formData.tt_teaser_text.value;
	}

	if (newsItem.formData?.tt_teaser_text_detail_page?.value) {
		return newsItem.formData.tt_teaser_text_detail_page?.value;
	}

	var xmlString = newsItem.formData?.tt_text?.value;
	var doc = new DOMParser().parseFromString(xmlString, "text/xml");

	const list = doc.querySelector("ul");
	if (list) {
		return list.children[0].textContent;
	}

	const p = doc.querySelector("p");
	if (p) {
		return p.textContent;
	}

}

export function mapTime(eventItem) {
	const time = eventItem.formData?.tt_opening_hours?.value;

	if (time) {
		return time;
	}

	return "";
}

export function mapAddress(eventItem) {
	const addresses = [
		eventItem.formData?.tt_address?.value
	]
	if (eventItem.formData?.tt_address_addition?.value) {
		addresses.push(eventItem.formData?.tt_address_addition?.value,);
	}
	if (eventItem.formData?.tt_city?.value) {
		addresses.push(eventItem.formData?.tt_city?.value);
	}

	const address = addresses.join(', ');

	return address;
}

export function mapDate(newsItem) {
	const language = newsItem.locale.language;
	const country = newsItem.locale.country;
	const date = new Date(newsItem.formData?.tt_date?.value);
	const options = {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	}
	return date.toLocaleDateString(`${language}-${country}`, options);
}

export function isDateEqual(date1, date2){
	const d1 =  new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	const d2 =  new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	return d1.getTime() === d2.getTime();
}


export function mapEventDateDetails(eventItem) {
	const dateDetails = [];
	const language = eventItem.locale.language;
	const country = eventItem.locale.country;
	const startDate = new Date(eventItem.formData?.tt_date?.value);;
	const endDate = eventItem.formData?.tt_end_date?.value ? new Date(eventItem.formData?.tt_end_date?.value) : null;
	const locale = `${language}-${country}`;
	const timeZone = { timeZone: "Europe/Berlin" }
	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		...timeZone
	};

	function isValidDate(d) {
		return d instanceof Date && !isNaN(d);
	}

	if (isValidDate(startDate)) {
		const date1 = {
			date: new Intl.DateTimeFormat(locale, options).format(startDate),
			dateYear: new Intl.DateTimeFormat(locale, { ...timeZone, year: 'numeric', }).format(startDate),
			dateDay: new Intl.DateTimeFormat(locale, { ...timeZone, day: '2-digit', }).format(startDate),
			dateMonth: new Intl.DateTimeFormat(locale, { ...timeZone, month: '2-digit', }).format(startDate),
			dateMonthFull: new Intl.DateTimeFormat(locale, { ...timeZone, month: 'long' }).format(startDate),
			dateMonthAbbr: new Intl.DateTimeFormat(locale, { ...timeZone, month: 'short' }).format(startDate),
		}
		dateDetails.push(date1);
	}


	if (isValidDate(endDate) && !isDateEqual(startDate, endDate)) {
		const date2 = {
			date: new Intl.DateTimeFormat(locale, options).format(endDate),
			dateYear: new Intl.DateTimeFormat(locale, { ...timeZone, year: 'numeric', }).format(endDate),
			dateDay: new Intl.DateTimeFormat(locale, { ...timeZone, day: '2-digit', }).format(endDate),
			dateMonth: new Intl.DateTimeFormat(locale, { ...timeZone, month: '2-digit', }).format(endDate),
			dateMonthFull: new Intl.DateTimeFormat(locale, { ...timeZone, month: 'long', }).format(endDate),
			dateMonthAbbr: new Intl.DateTimeFormat(locale, { ...timeZone, month: 'short', }).format(endDate),
		}
		dateDetails.push(date2);
	}

	return dateDetails;
}

export function mapTitle(newsItem) {
	if (newsItem.formData?.tt_title?.value) {
		return newsItem.formData?.tt_title?.value;
	}

	if (newsItem.formData?.tt_title_detail_page?.value) {
		return newsItem.formData?.tt_title_detail_page?.value;
	}

	return '';
}

export function mapCategoryHeadline(newsItem, categoryHeadline) {
	if (newsItem.entityType === SOCIAL_MEDIA_ENTITY_TYPE) {
		return newsItem.formData?.tt_social_media_service?.value?.label;
	}

	if (categoryHeadline) {
		return categoryHeadline;
	}


	return newsItem.entityType;

}

export function mapImage(mediaMasterData = [], item, cdnRoot) {
	if (mediaMasterData.length === 0) {
		return undefined;
	}

	const imageItem = mediaMasterData._embedded["rh:doc"].find(img => img._id === item.image.id);

	if (!imageItem) {
		return undefined;
	}


	return {
		content: {
			fallbackSrc: `${cdnRoot}${imageItem.resolutionsMetaData['1_1_format_s'].seoRoute}`,
			alt: mapImageDescription(imageItem),
			title: mapImageTitle(imageItem),
			items: [
				{
					sizes: "(min-width: 1440px) 206px, (min-width: 1024px) 148px, 110px",
					srcset: `${cdnRoot}${imageItem.resolutionsMetaData['1_1_format_s'].seoRoute} ${imageItem.resolutionsMetaData['1_1_format_s'].width}w, ${cdnRoot}${imageItem.resolutionsMetaData['1_1_format_m'].seoRoute} ${imageItem.resolutionsMetaData['1_1_format_m'].width}w`
				}
			]
		}
	}
}


export function mapImageTitle(imageItem) {
	const imgCopyrightTitle = imageItem?.metaFormData?.FS_0x8298?.value;
	const imageDescription = mapImageDescription(imageItem);

	if (imgCopyrightTitle) {
		if (imageDescription) {
			return `${imageDescription} | © ${imgCopyrightTitle}`;
		} else {
			return `© ${imgCopyrightTitle}`;
		}
	} else {
		return imageDescription;
	}
}

export function mapImageDescription(imageItem) {
	const { language } = imageItem.locale;

	if (language === 'en') {
		return imageItem.metaFormData?.md_imagedescription_en?.value;
	}

	return imageItem.metaFormData?.md_imagedescription?.value;
}

export function mapNewsroomItem(newsItem, mediaId, categoryHeadline) {
	return {
		_id: newsItem._id,
		date: mapDate(newsItem),
		fs_date: newsItem.formData.tt_date.value,
		formats: mapFormats(newsItem),
		description: mapDescription(newsItem),
		editorialType: newsItem.formData.tt_editorial_type.value.identifier,
		id: newsItem.identifier,
		translatedLangs: mapLanguage(newsItem),
		date_sort: newsItem.formData.tt_date.value,
		categoryType: newsItem.formData.tt_category.value?.identifier,
		category: newsItem.entityType,
		categoryAddition: '',
		categoryHeadline: mapCategoryHeadline(newsItem, categoryHeadline),
		link: {
			href: newsItem.route,
			text: mapTitle(newsItem)
		},
		image: {
			id: mediaId
		},
		dateDetails: mapEventDateDetails(newsItem),
		address: mapAddress(newsItem),
		time: mapTime(newsItem)
	}
}

export async function mapNewsData(newsData, config, pageSize, mediaCallback) {
	const newsItemMediaIds = [];
	const mappedNewsData = [];

	if (!newsData._embedded) {
		return returnDataMapper(newsData, null);
	}


	for (const newsItem of newsData._embedded["rh:doc"]) {
		const mediaId = mapMediaId(newsItem);
		if (mediaId) {
			newsItemMediaIds.push({ _id: mediaId });
		}
		mappedNewsData.push(mapNewsroomItem(newsItem, mediaId, config.categoryHeadline));
	}

	const mediaMasterData = newsItemMediaIds.length > 0 ?
		await mediaCallback(config, newsItemMediaIds, 1, pageSize)
		: [];

	const result = mappedNewsData.map(item => {
		return {
			...item,
			image: mapImage(mediaMasterData, item, config.cdnpath)
		};
	});

	return returnDataMapper(newsData, result);
}

export function mapTopics(eventfilteritems, topics) {
	return eventfilteritems?.themeitems.map(topic => {
		const mappedTopics = topics._embedded["rh:doc"]
			.filter(item => `fl_${item.formData.tt_fe_filter_key.value}` === topic.id)
			.map(t => t.identifier);
		const newTopic = Object.assign({}, topic);
		newTopic.value = mappedTopics.join(',');
		return newTopic;
	});
}


function returnDataMapper(newsData, result) {
	let data = {
		_size: newsData._size,
		_total_pages: newsData._total_pages,
		_returned: newsData._returned,
		_links: newsData._links,
	}

	if (result) {
		data._embedded = {
			"rh:doc": result
		}
	}



	return {
		data
	};
}
